import Input, { InputProps } from "@ancon/wildcat-ui/web/orderweb/Input";
import "@ancon/wildcat-ui/web/orderweb/Input/Input.css";

export type { InputProps };

export default Input;
